import React from 'react'
import { useIntl } from 'react-intl'
import { useTasks } from 'contexts/tasks'
import { advancedApplied } from 'components/filter/utilities'
import { compact } from 'utilities/array'
import Filter from 'components/filter'

const TasksFilter = props => {
    const { formatMessage } = useIntl()

    const {
        filter,
        setTasksFilter: setFilter,
        tasks: items,
        fetching,
        hasFetched
    } = useTasks()

    const advancedFields = compact([
        {
            type: 'radiobuttons',
            name: 'completed',
            label: formatMessage({
                id: ['true', 'false'].includes(filter?.completed) ?
                    (filter?.completed === 'true') ?
                        'noun_completed_plural' :
                        'noun_uncompleted_plural' :
                    'all_plural',
                defaultMessage: ['true', 'false'].includes(filter?.completed) ?
                    (filter?.completed === 'true') ?
                        'Completed' :
                        'Uncompleted' :
                    'All'
            }),
            field: {
                defaultValue: '',
                resettable: true,
                options: [
                    {
                        id: 'all',
                        value: '',
                        name: formatMessage({
                            id: 'all_plural',
                            defaultMessage: 'All'
                        }),
                        checked: !['true', 'false'].includes(filter?.completed),
                        className: 'centered'
                    },
                    {
                        id: 'uncompleted',
                        value: 'false',
                        name: formatMessage({
                            id: 'noun_uncompleted_plural',
                            defaultMessage: 'Uncompleted'
                        }),
                        checked: filter?.completed === 'false',
                        className: 'centered'
                    },
                    {
                        id: 'completed',
                        value: 'true',
                        name: formatMessage({
                            id: 'noun_completed_plural',
                            defaultMessage: 'Completed'
                        }),
                        checked: filter?.completed === 'true',
                        className: 'centered'
                    }
                ]
            }
        }
    ])

    return (
        <Filter
            {...props}
            filter={filter}
            setFilter={setFilter}
            advancedFields={advancedFields}
            items={items}
            fetching={fetching}
            hasFetched={hasFetched}
            resettable={false}
            salt="tasks" />
    )
}

const advancedNames = ['completed']

export const areAdvancedFiltersApplied = advancedApplied(advancedNames)

export const areFiltersApplied = filter => areAdvancedFiltersApplied(filter)

export default TasksFilter